<template>
    <router-view />
</template>

<script>
    export default {
        name: "AdminScriptLayout"
    }
</script>

<style scoped>

</style>